import dateFns from 'date-fns';
import * as storage from '../services/storage.js';
import { addFingerPrintToUrl } from '../fingerprint.js';

window.storage = storage;

export const getStats = async () => {
    const storedStats = storage.getStats();

    const isStoredStatsValid =
        storedStats &&
        storedStats.expiration &&
        dateFns.isBefore(new Date(), new Date(storedStats.expiration));

    if (isStoredStatsValid) {
        const result = await (new Promise(resolve => {
            setTimeout(() => resolve(storedStats), 0);
        }));
        return result;
    }
    else {
        storage.clearStats();

        const url = addFingerPrintToUrl(process.env.TRANSLATED_API_URL + '/utils/getStats');

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json();
        storage.storeStats(Object.assign({}, data, { expiration: dateFns.addHours(new Date(), 1) }));
        return data;
    }
};

export const getInstantQuoteDefault = async () => {
    const storedInstantQuoteDefault = storage.getInstantQuoteDefault();
    const isStoredInstantQuoteDefaultValid =
        storedInstantQuoteDefault &&
        storedInstantQuoteDefault.expiration &&
        dateFns.isBefore(new Date(), new Date(storedInstantQuoteDefault.expiration));

    if (isStoredInstantQuoteDefaultValid) {
        return storedInstantQuoteDefault;
    } else {
        storage.clearInstantQuoteDefault();

        const url = addFingerPrintToUrl(process.env.TRANSLATED_API_URL + '/utils/getDefaults');

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });
        const data = await response.json();
        storage.storeInstantQuoteDefault(
            Object.assign({}, data, { expiration: dateFns.addHours(new Date(), 1) }),
        );
        return data;
    }
};